import * as React from 'react';

import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';
import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';

import _t from 'i18n!nls/xdp';

const KeyInformationEarnCertificate = () => {
  const { enableXDPRedesignPhase1 } = useXDPRedesignPhase1Data();

  if (enableXDPRedesignPhase1) {
    const title = _t('Earn a career credential');
    const subtitle = _t('Share your expertise with employers');

    return <KeyInformationDetailsItem title={title} subtitle={subtitle} />;
  }

  return <KeyInformationDetailsItem title={_t('Earn a Certificate')} subtitle={_t('With paid plans')} />;
};

export default KeyInformationEarnCertificate;
